import Script from "next/script"
import React from "react"
import { siteUrl } from "utils/getSiteUrl"
import { getStaticFile } from "utils/getStaticFile"

export const defaultSchema = (locale: "en-GB" | "en-US") => {
  return Object.freeze({
    "@context": "http://schema.org",
    "@type": "Organization",
    legalName: "Beauty Pie",
    url: `${siteUrl}${locale === "en-US" ? "/us" : ""}`,
    contactPoint: [
      {
        "@type": "ContactPoint",
        telephone: "08081648264",
        contactType: "customer service",
      },
    ],
    logo: `${siteUrl}${getStaticFile("/images/beauty-pie-logo.jpg")}`,
    sameAs: [
      "https://www.facebook.com/beautypieofficial",
      "https://twitter.com/beautypie",
      "https://www.youtube.com/channel/UC9f3oNheJuzjPkFE2a24bDA",
      "https://www.instagram.com/beautypie/",
      "https://www.pinterest.co.uk/Beautypie/",
    ],
  })
}

type Props = {
  locale: "en-GB" | "en-US"
}

export const DefaultSchema: React.FC<Props> = ({ locale }) => {
  return (
    <Script type="application/ld+json">
      {JSON.stringify(defaultSchema(locale ?? "en-GB"))}
    </Script>
  )
}
